import styled from 'styled-components';
const playIconSize = '1em';

const commonGameAssetsFolder =
  process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST + '/commonGameAssets';

export const StyledTextWithAudio = styled.div`
  .playing {
    font-weight: bold;
  }
  .audio-playing {
    position: absolute;
    margin-left: 0.2em;
    display: inline-block;
    width: ${playIconSize};
    height: ${playIconSize};
    background: url('${commonGameAssetsFolder}/audio_icon_playing_2.svg');
    background-size: calc(${playIconSize} * 5) ${playIconSize};
    transform: translateY(0.15em);

    animation: soundPlaying steps(5) 0.4s infinite;
  }

  @keyframes soundPlaying {
    100% {
      background-position: calc(-5 * ${playIconSize});
    }
  }
`;
